import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import getColor from "@insite/mobius/utilities/getColor";
import { ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: unset;
            font-style: normal;
            padding: 0px 8px 0 0;
            font-weight: ${TYPOGRAPHY.sortSelectLabel.weight} !important;
            font-size: ${TYPOGRAPHY.sortSelectLabel.size} !important;
            line-height: ${TYPOGRAPHY.sortSelectLabel.lineHeight} !important;
            letter-spacing: ${TYPOGRAPHY.sortSelectLabel.letterSpacing} !important;
            color: ${getColor("text.accent")} !important;
        `,
    },
    cssOverrides: {
        formField: css`
            justify-content: flex-end;
            align-items: center;
        `,
        inputSelect: css`
            border: 1px solid ${getColor("common.border")};
            /* border: 1px solid blue !important; */
            border-radius: 2px;
            /* Beats the brand-wide form field height applied in Start.tsx. */
            height: ${ELEMENTS.sortSelect.height} !important;
            color: ${getColor("text.main")} !important;
            font-size: ${TYPOGRAPHY.sortSelectInput.size} !important;
            > option {
                color: ${getColor("text.main")} !important;
            }
        `,
        formInputWrapper: css`
            width: 150px;
            margin-right: ${ELEMENTS.sortSelect.marginRight};
            
            span {
                height: ${ELEMENTS.sortSelect.height} !important;
                top: 0 !important;
                padding: 0 8px !important;
            }
        `,
    },
};
